module.exports = __webpack_public_path__ + "static/media/video_thumb3.62069c65.png";